<template>
    <app-framework>
        <template v-if="study" v-slot:subtitle>
            <tw-divider color="white"
                        width="56"
                        class="mb-3"
            ></tw-divider>
            {{ study.title }}
        </template>
        <overlay style="top: 0;" v-model="showVideoOverlay">
            <row align="center" class="h-full relative" justify="center">
                <video-player :play="showVideoOverlay"
                              :src="video.src"
                              class="absolute"
                              max-width="1000px"
                              v-if="video.src"
                ></video-player>
            </row>
        </overlay>
        <loader v-if="loading"></loader>
<!--        <div class="rotated-background-section bg-block"></div>-->
<!--        <div class="bg-circle"></div>-->
<!--        <div class="bg-dot"></div>-->
        <row class="text-secondary" v-if="projectScope && whatAreWeSolving && solution">
            <div class="w-full mb-8" style="height: 100px;">
                <transition name="fade">
                    <column class="mb-10 xs:items-center sm:items-center md:items-end"
                            cols="full"
                            v-if="logo.file"
                    >
                        <img :src="logo.file.url" alt="logo" style="max-height: 100px;">
                    </column>
                </transition>
            </div>
            <column class="xs:mb-20 sm:mb-24 md:mb-32 xs:items-center sm:items-center md:items-end" cols="full">
                <tw-divider class="mb-5" color="primary" width="56"></tw-divider>
                <div
                    class="poppins-bold tracking-normal xs:text-3xl sm:text-5xl xs:leading-relaxed sm:leading-higher mb-10">
                    Project Scope
                </div>
                <div class="xs:text-center sm:text-center md:text-right xs:text-xl sm:text-2xl tracking-normal xs:leading-snug sm:leading-relaxed text-center"
                     style="max-width: 1000px;"
                     v-html="projectScope"
                ></div>
            </column>
            <column class="xs:mb-20 sm:mb-24 md:mb-32 xs:items-center sm:items-center md:items-start" cols="full">
                <tw-divider class="mb-5" color="primary" width="56"></tw-divider>
                <div
                    class="xs:text-center sm:text-center md:text-left poppins-bold tracking-normal xs:text-3xl sm:text-5xl xs:leading-relaxed sm:leading-higher mb-10">
                    What Are We Solving?
                </div>
                <div class="xs:text-center sm:text-center md:text-left xs:text-xl sm:text-2xl tracking-normal xs:leading-snug sm:leading-relaxed text-center"
                     style="max-width: 1000px;"
                     v-html="whatAreWeSolving"
                ></div>
            </column>
            <column class="xs:items-center sm:items-center md:items-end" cols="full">
                <tw-divider class="mb-5" color="primary" width="56"></tw-divider>
                <div
                    class="poppins-bold tracking-normal xs:text-3xl sm:text-5xl xs:leading-relaxed sm:leading-higher mb-10">
                    Solution
                </div>
                <div class="xs:text-center sm:text-center md:text-right xs:text-xl sm:text-2xl tracking-normal xs:leading-snug sm:leading-relaxed text-center"
                     style="max-width: 1000px;"
                     v-html="solution"
                ></div>
                <tw-btn @click="showVideoOverlay = true"
                        class="tracking-widest poppins-bold mt-6"
                        color="primary" height="75"
                        no-padding outlined
                        style="padding: 7px;"
                        v-if="video.src"
                        width="278"
                >
                    <tw-btn color="primary" fab size="61">
                        <icon color="white" icon="play"></icon>
                    </tw-btn>
                    <div class="px-5 text-primary" style="font-size: 14px;">
                        PLAY VIDEO
                    </div>
                </tw-btn>
                <tw-btn @click="openEbook()"
                        class="tracking-widest poppins-bold mt-6"
                        color="primary" height="75"
                        no-padding outlined
                        style="padding: 7px;"
                        v-if="hasEbook"
                        width="278"
                >
                    <tw-btn color="primary" fab size="61">
                        <icon color="white" icon="book-open-variant"></icon>
                    </tw-btn>
                    <div class="px-5 text-primary" style="font-size: 14px;">
                        VIEW EBOOK
                    </div>
                </tw-btn>
            </column>
            <transition name="fade">
                <column align="center" class="mt-20" cols="full" v-if="infoGraphic.file">
                    <img :src="infoGraphic.file.url"
                         alt="info_graphic"
                         style="width: 100%; max-width: 1300px; border-radius: 40px;"
                    >
                </column>
            </transition>
        </row>
    </app-framework>
</template>

<script>
    import { documentToHtmlString } from "@contentful/rich-text-html-renderer";

    export default {
        name: "CaseStudy",
        props: {
            studyId: {
                type: String
            }
        },
        components: {
            'app-framework': () => import('@/components/layout/AppFramework.vue'),
            'loader': () => import('@/components/display/Loader.vue'),
            'tw-divider': () => import('@/components/Divider.vue'),
            'tw-btn': () => import('@/components/Btn.vue'),
            icon: () => import('@/components/display/Icon.vue'),
            'overlay': () => import('@/components/Overlay.vue'),
            'video-player': () => import('@/components/display/VideoPlayer.vue'),
        },
        data: () => ({
            showVideoOverlay: false,
            study: null,
            loading: true,
            projectScope: null,
            whatAreWeSolving: null,
            solution: null,
            logo: {
                id: null,
                file: null
            },
            infoGraphic: {
                id: null,
                file: null
            },
            video: {
                id: null,
                src: null
            },
        }),
        methods: {
            getStudy() {
                // this.$contentful.getEntry(this.studyId).then(
                //     (resp) => {
                //         this.study = resp.fields;
                this.study = this.$route.params.study;
                        this.projectScope = documentToHtmlString(this.study.content);
                        this.whatAreWeSolving = documentToHtmlString(this.study.whatAreWeSolving);
                        this.solution = documentToHtmlString(this.study.solution);
                        if (this.study.logo) {
                            this.logo.id = this.study.logo.sys.id;
                        }
                        if (this.study.infographic) {
                            this.infoGraphic.id = this.study.infographic.sys.id;
                        }
                        if (this.study.video) {
                            this.video.id = this.study.video.sys.id;
                        }
                        this.getAssets();
                        this.loading = false;
                    // }
                // );
            },
            getAssets() {
                if (this.logo.id) {
                    this.$contentful.getAsset(this.logo.id).then(
                        (asset) => {
                            this.logo.file = asset.fields.file;
                        }
                    );
                }
                if (this.infoGraphic.id) {
                    this.$contentful.getAsset(this.infoGraphic.id).then(
                        (asset) => {
                            this.infoGraphic.file = asset.fields.file;
                        }
                    );
                }
                if (this.video.id) {
                    this.$contentful.getAsset(this.video.id).then(
                        (asset) => {
                            this.video.src = 'https:' + asset.fields.file.url;
                        }
                    );
                }
            },
            openEbook(){
                if(this.hasEbook){
                    window.open(window.location.href + '/ebook' ,'_blank');
                }
            }
            // playVideo() {
            //
            // }
        },
        computed:{
            hasEbook(){
                return this.study && this.study.client && ['SEC','STC',"Ma'aden","Medihelp"].includes(this.study.client);
            },
        },
        mounted() {
            this.getStudy();
        }
    }
</script>

<style>
    p {
        padding-bottom: 15px;
    }

    h1 {
        font-size: 2em;
    }

    h2 {
        font-size: 1.5em;
    }

    ul {
        list-style: outside disc;
        margin-left: 17px;
    }

    /*.rotated-background-section {*/
    /*    width: 1944px;*/
    /*    height: 916px;*/
    /*    position: absolute;*/
    /*    border-radius: 166px;*/
    /*}*/

    .fade-enter-active, .fade-leave-active {
        transition: opacity .5s;
    }

    .fade-enter, .fade-leave-to {
        opacity: 0;
    }

    /*@media only screen and (max-width: 413px) {*/
    /*    .bg-block {*/
    /*        background: linear-gradient(to bottom, rgba(1, 116, 234, 1), rgba(1, 116, 234, 0));*/
    /*        !*background-color: red;*!*/
    /*        opacity: 0.05;*/
    /*        left: 48px;*/
    /*        top: 115px;*/
    /*        transform: translateX(114px) translateY(742px) rotateZ(-7deg);*/
    /*        z-index: 0;*/
    /*    }*/

    /*    .bg-circle {*/
    /*        width: 166px;*/
    /*        height: 166px;*/
    /*        background-color: rgba(1, 116, 234, 0.1);*/
    /*        border-radius: 50%;*/
    /*        left: -60px;*/
    /*        top: 470px;*/
    /*        position: absolute;*/
    /*    }*/

    /*    .bg-dot {*/
    /*        width: 24px;*/
    /*        height: 24px;*/
    /*        box-shadow: 0 0 0 1px rgba(1, 116, 234, 0.2);*/
    /*        border-radius: 50%;*/
    /*        left: 10px;*/
    /*        top: 660px;*/
    /*        position: absolute;*/
    /*    }*/
    /*}*/

    /*@media only screen and (min-width: 414px) and (max-width: 639px) {*/
    /*    .bg-block {*/
    /*        background: linear-gradient(to bottom, rgba(1, 116, 234, 1), rgba(1, 116, 234, 0));*/
    /*        !*background-color: red;*!*/
    /*        opacity: 0.05;*/
    /*        left: 48px;*/
    /*        top: 115px;*/
    /*        transform: translateX(114px) translateY(542px) rotateZ(-7deg);*/
    /*        z-index: 0;*/
    /*    }*/

    /*    .bg-circle {*/
    /*        width: 166px;*/
    /*        height: 166px;*/
    /*        background-color: rgba(1, 116, 234, 0.1);*/
    /*        border-radius: 50%;*/
    /*        left: -60px;*/
    /*        top: 500px;*/
    /*        position: absolute;*/
    /*    }*/

    /*    .bg-dot {*/
    /*        width: 24px;*/
    /*        height: 24px;*/
    /*        box-shadow: 0 0 0 1px rgba(1, 116, 234, 0.2);*/
    /*        border-radius: 50%;*/
    /*        left: 30px;*/
    /*        top: 700px;*/
    /*        position: absolute;*/
    /*    }*/
    /*}*/

    /*@media only screen and (min-width: 640px) and (max-width: 1919px) {*/
    /*    .bg-block {*/
    /*        background: linear-gradient(to bottom, rgba(1, 116, 234, 1), rgba(1, 116, 234, 0));*/
    /*        opacity: 0.05;*/
    /*        left: 48px;*/
    /*        top: 115px;*/
    /*        transform: translateX(314px) translateY(542px) rotateZ(-7deg);*/
    /*        z-index: 0;*/
    /*    }*/

    /*    .bg-circle {*/
    /*        width: 166px;*/
    /*        height: 166px;*/
    /*        background-color: rgba(1, 116, 234, 0.1);*/
    /*        border-radius: 50%;*/
    /*        left: 20px;*/
    /*        top: 800px;*/
    /*        position: absolute;*/
    /*    }*/

    /*    .bg-dot {*/
    /*        width: 24px;*/
    /*        height: 24px;*/
    /*        box-shadow: 0 0 0 1px rgba(1, 116, 234, 0.2);*/
    /*        border-radius: 50%;*/
    /*        left: 60px;*/
    /*        top: 980px;*/
    /*        position: absolute;*/
    /*    }*/
    /*}*/

    /*@media only screen and (min-width: 1920px) {*/
    /*    .bg-block {*/
    /*        background: linear-gradient(to bottom, rgba(1, 116, 234, 1), rgba(1, 116, 234, 0));*/
    /*        opacity: 0.05;*/
    /*        left: 48px;*/
    /*        top: 115px;*/
    /*        transform: translateX(914px) translateY(842px) rotateZ(-7deg);*/
    /*        z-index: 0;*/
    /*    }*/

    /*    .bg-circle {*/
    /*        width: 166px;*/
    /*        height: 166px;*/
    /*        background-color: rgba(1, 116, 234, 0.1);*/
    /*        border-radius: 50%;*/
    /*        !*left: 60px;*!*/
    /*        !*top: 920px;*!*/
    /*        transform: translateX(-950px) translateY(140px) rotateZ(-7deg);*/
    /*        position: absolute;*/
    /*    }*/

    /*    .bg-dot {*/
    /*        width: 24px;*/
    /*        height: 24px;*/
    /*        box-shadow: 0 0 0 1px rgba(1, 116, 234, 0.2);*/
    /*        border-radius: 50%;*/
    /*        !*left: 40px;*!*/
    /*        !*top: 1100px;*!*/
    /*        transform: translateX(-1050px) translateY(320px) rotateZ(-7deg);*/
    /*        position: absolute;*/
    /*    }*/
    /*}*/
</style>
